import { render, staticRenderFns } from "./SendChannelsStep.vue?vue&type=template&id=137f2215&scoped=true"
import script from "./SendChannelsStep.vue?vue&type=script&lang=ts"
export * from "./SendChannelsStep.vue?vue&type=script&lang=ts"
import style0 from "./SendChannelsStep.vue?vue&type=style&index=0&id=137f2215&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137f2215",
  null
  
)

export default component.exports